<template>
  <section>
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200 lg:border-0 lg:pt-0">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-12 md:pb-20">
          <h2 class="h2 mb-4">サービス紹介</h2>
          <p class="text-xl text-gray-600">
            月額会員になっていただくと、下記の各種イベントに参加し放題！ 一緒に健康になりましょう！
          </p>
          <a
            class="flex pl-16 mx-auto mt-4 p-4 bg-theme-100 hover:bg-theme-200 button"
            data-aos="fade-up"
            href="calendar"
          >
            <img class="w-3 mr-2" :src="require('@/images/arrow-white.svg')" />
            <span class="block font-bold text-white">イベントカレンダーはこちらから！</span>
          </a>
        </div>

        <!-- Items -->
        <div
          class="max-w-sm mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-16 items-start md:max-w-2xl lg:max-w-none"
          data-aos-id-blocks
        >
          <!-- 1st item -->
          <div class="relative flex flex-col items-center" data-aos="fade-up" data-aos-anchor="[data-aos-id-blocks]">
            <h4 class="h4 mb-4">ストレッチ</h4>
            <figure
              class="relative w-full h-0 pb-9/16 md:pb-3/4 lg:pb-9/16 overflow-hidden transform md:-translate-y-2 xl:-translate-y-4 group-hover:translate-x-0 group-hover:translate-y-0 transition duration-700 ease-out"
            >
              <img
                class="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition duration-700 ease-out"
                :src="require('@/images/features-support-01.jpg')"
                width="540"
                height="303"
                alt="Blog post 01"
              />
            </figure>
            <p class="text-lg text-gray-600 text-left">
              解剖生理学に基づいたストレッチで、凝り固まった体や痛みを解消していきましょう。毎回様々なテーマや症状に合わせて実施していきます。<br />
              レッスン時間:30分<br />
              質疑応答:10分間
            </p>
          </div>

          <!-- 2nd item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-4">エクササイズ</h4>
            <figure
              class="relative w-full h-0 pb-9/16 md:pb-3/4 lg:pb-9/16 overflow-hidden transform md:-translate-y-2 xl:-translate-y-4 group-hover:translate-x-0 group-hover:translate-y-0 transition duration-700 ease-out"
            >
              <img
                class="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition duration-700 ease-out"
                :src="require('@/images/features-support-02.jpg')"
                width="540"
                height="303"
                alt="Blog post 01"
              />
            </figure>
            <p class="text-lg text-gray-600 text-left">
              軽い負荷から重い負荷まで運動を行なっていきます。基本的に運動器具は無く自重で行っていける運動です。1人よりみんなで楽しく一緒にやっていくことで続けられます！<br />
              レッスン時間:30分間<br />
              質疑応答:10分間<br />
            </p>
          </div>

          <!-- 3rd item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-4">健康セミナー</h4>
            <figure
              class="relative w-full h-0 pb-9/16 md:pb-3/4 lg:pb-9/16 overflow-hidden transform md:-translate-y-2 xl:-translate-y-4 group-hover:translate-x-0 group-hover:translate-y-0 transition duration-700 ease-out"
            >
              <img
                class="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition duration-700 ease-out"
                :src="require('@/images/features-support-03.jpg')"
                width="540"
                height="303"
                alt="Blog post 01"
              />
            </figure>
            <p class="text-lg text-gray-600 text-left">
              肩こり、腰痛などの症状別のメカニズムから、睡眠、ダイエットなど世の中に溢れている健康トレンドの話まで、健康に関することをわかりやすく面白くかつ丁寧にお伝えします。これであなたも健康博士！<br />
              セミナー時間:30分間<br />
              質疑応答:10分間<br />
            </p>
          </div>

          <!-- 4th item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-4">ヨガ教室</h4>
            <p class="text-lg text-gray-600 text-center">
              只今準備中。近日追加予定！
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeaturesKaradaSupport",
}
</script>
